import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../bl-dialog.action';
import { BlDialogState } from '../bl-dialog.state';
import { getFocus } from '../function/get-focus.function';

import { ListDocuments, ListDocumentsResult } from './list-documents.action';

export function listDocumentsReducer(
    state: BlDialogState,
    action: PayloadAction<
        ActionType.COACHING__BL__LIST_DOCUMENTS,
        ListDocuments
    >,
): BlDialogState {
    return {
        ...state,
        pending: {
            ...state.pending,
            documents: true,
        },
    };
}

export function listDocumentsResultReducer(
    state: BlDialogState,
    action: PayloadAction<
        ActionType.COACHING__BL__LIST_DOCUMENTS_RESULT,
        ListDocumentsResult
    >,
): BlDialogState {
    try {
        const focus = getFocus(
            state?.behaviours,
            state?.subBehaviours,
            action.payload.documents?.[0],
        );

        return {
            ...state,
            pending: {
                ...state.pending,
                documents: false,
            },
            documents: action.payload.documents,
            focus,
        };
    } catch {
        return state;
    }
}
